import { useCallback, useRef } from 'react';

export interface IdempotencyStamp {
    key: string;
    payload: string;
}

// Resubmitting the exact payload reuses its key, so a retry after a lost response can't create twice.
export function idempotencyStampFor(
    previous: IdempotencyStamp | null,
    payload: string,
    createKey: () => string
): IdempotencyStamp {
    return previous?.payload === payload ? previous : { key: createKey(), payload };
}

export function useIdempotencyKey(): (payload: string) => string {
    const stampRef = useRef<IdempotencyStamp | null>(null);
    return useCallback((payload: string) => {
        stampRef.current = idempotencyStampFor(stampRef.current, payload, () =>
            crypto.randomUUID()
        );
        return stampRef.current.key;
    }, []);
}
